/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { CustomFilter } from '../../components';
import { generateReportDigitadorDiario } from '../../store/nsir/actions';
import * as selectorsAuth from "../../store/auth/reducer";
import * as Role from "../../constants/role";
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
}));

const defaultFilter = authData => ({ 
  inicio: moment().subtract(7, 'days').startOf('day').valueOf(), 
  fim: moment().endOf('day').valueOf(),
  dateTypes: ['DATA_DIGITACAO'],
  digitadorId: authData.role === Role.DIGITADOR ? [authData.id] : [],
})

const Reports = ({ authData, generateReportDigitadorDiario }) => {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12}>
        <CustomFilter
          onFilter={filter => {
            generateReportDigitadorDiario(filter)
          }}
          fields={[
            { field: "useDates", useDateTypes: true, useDateTypesReadOnly: true },
            { field: "useDigitador", multiSelect: true, disabled: (Role.ADMIN !== authData.role && Role.SUPER_ADMIN !== authData.role) },
            { field: "useCodigo", codigoLabel: "Código NSIR", md: 4 },
            { field: "useTipoServico", md: 4, xs: 12},
            { field: "useSubTipoServico", md: 4, xs: 12 },
            { field: "useMalha" },
            { field: "useGerencia" },
            { field: "usePolo" },
            { field: "useSubestacao" },
            { field: "useAlimentador" },
            { field: "useNsirStatus" },
          ]}
          defaultFilter={defaultFilter(authData)}
          defaultCollapseValue
          defaultCollapseUnmountOnExit={false}
          confirmButtonText="Exportar"
        />
      </Grid>
      <Grid item xs={12} className={classes.root}>
        Realize o filtro e exporte o Relatório de Digitações Diária
      </Grid>
    </Grid>
  );
};

const mapStateToProps = state => ({
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  generateReportDigitadorDiario,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Reports));